import * as React from 'react';
import { ViewpointBuilderFooter } from 'viewpointBuilder/components/ViewpointBuilderFooter';
import { AddFiltersSidebar } from './AddFiltersSidebar';
import { GraphVisualizationWithFilters } from './GraphVisualizationWithFilters';
import { ViewpointBuilderFiltersCommands } from './viewpointBuilderFiltersCommands';
import { TraversalBuilderViewState } from '../types';
import { PrimaryButtonConfig } from 'viewpointBuilder/openViewpointBuilder/getPrimaryButtonConfig';
import { WithMetamodelLoader } from '../components/WithMetamodelLoader';
import { ResizablePageBody } from '@ardoq/page-layout';
import type { I18nLocale } from '@ardoq/i18n';
import type { Locale } from '@ardoq/locale';

type AddFiltersTabContentProps = {
  state: TraversalBuilderViewState;
  commands: ViewpointBuilderFiltersCommands;
  closeViewpointBuilder: () => void;
  toggleGraphNodeSelection: (
    event: React.MouseEvent<Element, MouseEvent>
  ) => void;
  primaryButtonConfig: PrimaryButtonConfig;
  label: string;
  locale: Locale;
  i18nLocale: I18nLocale;
};

export const AddFiltersTabContent = ({
  commands,
  state,
  closeViewpointBuilder,
  toggleGraphNodeSelection,
  primaryButtonConfig,
  label,
  locale,
  i18nLocale,
}: AddFiltersTabContentProps) => {
  return (
    <WithMetamodelLoader
      isMetaModelLoaded={state.isMetaModelLoaded}
      closeViewpointBuilder={closeViewpointBuilder}
      i18nLocale={i18nLocale}
    >
      <ResizablePageBody
        skipPadding
        footerContent={
          <ViewpointBuilderFooter
            closeViewpointBuilder={closeViewpointBuilder}
            primaryButtonConfig={primaryButtonConfig}
            i18nLocale={i18nLocale}
          />
        }
        rightContent={
          <AddFiltersSidebar
            commands={commands}
            state={state}
            locale={locale}
            i18nLocale={i18nLocale}
          />
        }
        rightContentInitialWidth={530}
        rightContentMinWidth={400}
      >
        <GraphVisualizationWithFilters
          label={label}
          state={state}
          commands={commands}
          toggleGraphNodeSelection={toggleGraphNodeSelection}
        />
      </ResizablePageBody>
    </WithMetamodelLoader>
  );
};
